var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title",attrs:{"id":_vm.content.key}},[_vm._v(_vm._s(_vm.content.title))])}
var staticRenderFns = []

export { render, staticRenderFns }